export const varBounceOut = { animate: { scale: [0.9, 1.1, 0.3], opacity: [1, 1, 0] } };
